type FilterCountProps = {
	count: number
	/** What is counted, for the screen-reader label ("2 Status filters"). */
	label: string
}

/** The active-selection count on a filter trigger; nothing at zero. */
export const FilterCount = ({ count, label }: FilterCountProps) =>
	count > 0 ? (
		<span
			className="bg-primary text-primary-foreground flex size-5 items-center justify-center rounded-full text-xs"
			aria-label={`${count} ${label} filters`}
		>
			{count}
		</span>
	) : null
